import React from 'react';
import AdminUserDetailSection from './AdminUserDetailSection';

interface AdminUserDetailCreditsSectionProps {
  creditBalance: number;
  subscriptionPlanName: string | null;
  addCreditsAmount: string;
  setAddCreditsAmount: (v: string) => void;
  addCreditsDescription: string;
  setAddCreditsDescription: (v: string) => void;
  addCreditsLoading: boolean;
  expanded: boolean;
  onToggle: () => void;
  onAddCredits: () => void;
}

const AdminUserDetailCreditsSection: React.FC<AdminUserDetailCreditsSectionProps> = ({
  creditBalance,
  subscriptionPlanName,
  addCreditsAmount,
  setAddCreditsAmount,
  addCreditsDescription,
  setAddCreditsDescription,
  addCreditsLoading,
  expanded,
  onToggle,
  onAddCredits,
}) => {
  const rightContent = expanded ? (
    <div className="text-cyan-400 font-semibold text-base">{creditBalance}</div>
  ) : undefined;

  return (
    <AdminUserDetailSection
      sectionId="credits"
      title="Credits"
      expanded={expanded}
      onToggle={onToggle}
      rightContent={rightContent}
    >
      <div className="flex flex-wrap items-baseline gap-y-3 mb-4">
        <div className="pr-8 mr-8 border-r border-slate-600/50">
          <p className="text-xs text-gray-400 mb-1">Current Balance</p>
          <span className="text-2xl font-bold text-cyan-400">{creditBalance}</span>
        </div>
        <div className="pl-1">
          <p className="text-xs text-gray-400 mb-1">Subscription Plan</p>
          <span className="text-lg font-semibold text-amber-400/90">
            {subscriptionPlanName || 'No plan'}
          </span>
        </div>
      </div>
      <div className="border-t border-slate-700/40 pt-4">
        <h3 className="text-sm font-semibold text-white mb-3">Add Credits</h3>
        <div className="grid grid-cols-1 md:grid-cols-2 gap-3 mb-3">
          <div>
            <label className="block text-xs font-medium text-gray-300 mb-1">Amount</label>
            <input
              type="number"
              min={1}
              value={addCreditsAmount}
              onChange={(e) => setAddCreditsAmount(e.target.value)}
              className="w-full px-3 py-1.5 bg-white/5 border border-white/10 rounded-lg text-xs text-white placeholder-gray-500 focus:outline-none focus:ring-2 focus:ring-cyan-500"
              placeholder="e.g. 50"
              disabled={addCreditsLoading}
            />
          </div>
          <div>
            <label className="block text-xs font-medium text-gray-300 mb-1">Description (optional)</label>
            <input
              type="text"
              value={addCreditsDescription}
              onChange={(e) => setAddCreditsDescription(e.target.value)}
              className="w-full px-3 py-1.5 bg-white/5 border border-white/10 rounded-lg text-xs text-white placeholder-gray-500 focus:outline-none focus:ring-2 focus:ring-cyan-500"
              placeholder="e.g. Promotional credits"
              disabled={addCreditsLoading}
            />
          </div>
        </div>
        <button
          onClick={onAddCredits}
          disabled={addCreditsLoading || !addCreditsAmount.trim()}
          className="px-4 py-1.5 bg-gradient-to-r from-cyan-500 to-blue-600 text-white rounded-lg text-xs font-medium hover:from-cyan-600 hover:to-blue-700 disabled:opacity-60 transition-all"
        >
          {addCreditsLoading ? 'Adding...' : 'Add Credits'}
        </button>
      </div>
    </AdminUserDetailSection>
  );
};

export default AdminUserDetailCreditsSection;
